import SecxionLoader from './SecxionLoader';

const Loader = () => {
  return <SecxionLoader size="large" message="Loading..." />;
};

export default Loader;
